// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-row {
  background: #1C1E23;
  height: 7vh;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;
}

.header-col {
  display: flex;
  align-items: center;
}

.header-title {
  color: white;
  margin-left: 10px;
  font-weight: 600;
  font-style: italic;
  font-size: 17px;
}

@media (max-width: 768px) {
  .header-row {
    flex-direction: column;
    align-items: flex-start;
    height: auto;
    padding: 10px;
  }
  .header-col {
    width: 100%;
    justify-content: space-between;
  }
  .header-title {
    margin-left: 10px;
    font-size: 14px;
  }
  .header-logo {
    width: 30px;
  }
}
@media (max-width: 480px) {
  .header-title {
    font-size: 12px;
    margin-left: 5px;
  }
  .header-logo {
    width: 25px;
  }
}`, "",{"version":3,"sources":["webpack://./src/component/layout/Header.scss"],"names":[],"mappings":"AAIE;EACE,mBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;AAHJ;;AAME;EACE,aAAA;EACA,mBAAA;AAHJ;;AAWE;EACE,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AARJ;;AAYE;EACE;IACE,sBAAA;IACA,uBAAA;IACA,YAAA;IACA,aAAA;EATJ;EAYE;IACE,WAAA;IACA,8BAAA;EAVJ;EAaE;IACE,iBAAA;IACA,eAAA;EAXJ;EAcE;IACE,WAAA;EAZJ;AACF;AAeE;EACE;IACE,eAAA;IACA,gBAAA;EAbJ;EAgBE;IACE,WAAA;EAdJ;AACF","sourcesContent":["// .header-container {\n//     height: 97vh;\n//   }\n  \n  .header-row {\n    background: #1C1E23;\n    height: 7vh;\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0 20px;\n    box-sizing: border-box;\n  }\n  \n  .header-col {\n    display: flex;\n    align-items: center;\n  }\n  \n//   .header-logo {\n//     width: 40px; // Adjust the logo size as needed\n//     height: auto;\n//   }\n  \n  .header-title {\n    color: white;\n    margin-left: 10px;\n    font-weight: 600;\n    font-style: italic; // or the appropriate font style\n    font-size: 17px;\n  }\n  \n  // Responsive Design\n  @media (max-width: 768px) {\n    .header-row {\n      flex-direction: column;\n      align-items: flex-start;\n      height: auto;\n      padding: 10px;\n    }\n  \n    .header-col {\n      width: 100%;\n      justify-content: space-between;\n    }\n  \n    .header-title {\n      margin-left: 10px;\n      font-size: 14px;\n    }\n  \n    .header-logo {\n      width: 30px; // Adjust the logo size for smaller screens\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .header-title {\n      font-size: 12px;\n      margin-left: 5px;\n    }\n  \n    .header-logo {\n      width: 25px; // Adjust the logo size for smaller screens\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
